import {
    resourceIdFactory,
    resourceIdZodSchema,
} from "@@/shared/acquire/resources/resource-id";
import {
    isoAndUnixZodSchema,
    nowIsoAndUnix,
} from "@@/shared/date-time/iso-and-unix";
import { idZodSchema } from "@@/shared/id";
import { providerIdZodSchema } from "@@/shared/providers/provider-id";
import { requiredTranslatableZodSchema } from "@@/shared/translations/translation";
import { generateId } from "@@/utilities/generate-id";
import { z } from "zod";

const resourceAddCommandZodSchema = z.object({
    _id: idZodSchema,
    resourceId: resourceIdZodSchema,
    _type: z.literal("RESOURCE_ADD_COMMAND"),
    _createdAt: isoAndUnixZodSchema,
    providerId: providerIdZodSchema,
    title: requiredTranslatableZodSchema,
    quantity: z.number().min(0),
    type: z.enum(["RESOURCE_TABLE", "RESOURCE_GENERIC", "RESOURCE_RESERVED"]),
    quantityToCreate: z.number().int().positive(),
});
type ResourceAddCommand = z.infer<typeof resourceAddCommandZodSchema>;

const resourceAddCommandFactoryParamsZodObject =
    resourceAddCommandZodSchema.omit({
        _id: true,
        _type: true,
        _createdAt: true,
    });

type FactoryParams = z.infer<typeof resourceAddCommandFactoryParamsZodObject>;

const resourceAddCommandFactory = (
    params: FactoryParams,
): ResourceAddCommand => {
    const ResourceAddCommand: ResourceAddCommand = {
        ...params,
        _id: generateId({ prefix: "resource_add_command__" }),
        _type: "RESOURCE_ADD_COMMAND",
        resourceId: params.resourceId ?? resourceIdFactory(),
        _createdAt: nowIsoAndUnix(),
    };
    return ResourceAddCommand;
};

export {
    resourceAddCommandFactory,
    resourceAddCommandFactoryParamsZodObject,
    resourceAddCommandZodSchema,
};
export type {
    ResourceAddCommand,
    FactoryParams as ResourceAddCommandFactoryParams,
};
